import { v4 as uuidv4 } from "uuid";

const KEY = "ekumes_device_id";
let memoryId = null;

export const getDeviceId = () => {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = crypto?.randomUUID ? crypto.randomUUID() : uuidv4();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {}

  // sessionStorage (incognito fallback)
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = crypto?.randomUUID ? crypto.randomUUID() : uuidv4();
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch {}

  // memory fallback
  if (!memoryId) {
    memoryId = crypto?.randomUUID ? crypto.randomUUID() : uuidv4();
  }
  return memoryId;
};
